import Slider from 'components/gruenland/atoms/slider/Slider';
import { desktop } from 'helpers/utils/screensizes';
import CustomerReview from '../ratings/CustomerReview';

type Review = {
  ID: number;
  Rating: number;
  Review: string;
  Released: Date;
};

type Props = {
  reviews: Review[];
};

const ReviewsSlider: React.FC<Props> = ({ reviews }) => {
  return (
    <Slider
      slidesPerView={1.2}
      slidesPerGroup={1}
      dots={false}
      arrows={false}
      arrowsPosition="inside"
      allowTouchMove
      className="size-full"
      breakpoints={{
        [desktop]: {
          spaceBetween: 20,
          slidesPerView: 3,
          slidesPerGroup: 3,
        },
      }}
    >
      {reviews.map((t) => (
        <div key={t.ID} className="h-full">
          <CustomerReview key={t.ID} date={t.Released} rating={t.Rating} text={t.Review} />
        </div>
      ))}
    </Slider>
  );
};

export default ReviewsSlider;
